module.exports = __webpack_public_path__ + "img/icon-load.6633dc06.svg";